// extracted by mini-css-extract-plugin
module.exports = {"main-component":"day_main-component__3-CXu"};